module.exports = __webpack_public_path__ + "img/05_Module-1@2x.e925d85e.jpg";